import { message } from 'antd';
import pathToRegexp from 'path-to-regexp';
import moment from 'moment-timezone';
import ls from 'local-storage';
import duration from 'moment-duration-format';
import _ from 'lodash';
import Routes from '../routes';

const helpers = {
  getDefaultProjectId: (projects) => {
    let firstActiveProjectId = null;
    projects.forEach((project) => {
      if (!project.disabled) {
        firstActiveProjectId = project.id;
        return false;
      }
    });
    return firstActiveProjectId;
  },

  getSorterString: prop => (a, b) => {
    if (a[prop].toLowerCase() > b[prop].toLowerCase()) {
      return 1;
    }

    if (a[prop].toLowerCase() < b[prop].toLowerCase()) {
      return -1;
    }

    return 0;
  },

  getSorterNumber: prop => (a, b) => {
    return a[prop] - b[prop];
  },

  processException: (e) => {
    if (!e.success && e.statusCode === 401) {
      if (e.is2FAError) {
        window.location.href = '/#/profile/';
        return;
      }
      helpers.forceLogout();
      return;
    }

    const attributes = e.errors ? Object.keys(e.errors) : [];
    if (e.statusCode === 499) {
      return;
    }
    if (attributes.length && e.code !== 'IN_USE') {
      attributes.forEach((attr) => {
        e.errors[attr].forEach((validationMsg) => {
          message.error(validationMsg);
        });
      });
    } else {
      message.error(e.message);
    }
  },

  forceLogout: () => {
    window.setTimeout(() => {
      // clear local storage
      ls.clear();
      // clearing stores from all models
      window.location.href = '/';
    }, 1000);
  },

  createDateTimeFromString: (atomDateString) => {
    return new Date(atomDateString);
  },

  dateTimeToString: (dateObject) => {
    const locale = navigator.language || 'de-DE';
    // user system timezone will be used
    return dateObject.toLocaleString(locale);
  },

  getTimeFromDuration: (time, unit) => {
    duration(moment);
    return moment.duration(time, unit).format('h:mm:ss', { stopTrim: 'h' });
  },

  isHomePath: (path) => {
    return /^\/(\d+\/)?$/.test(path);
  },

  multipleSelectFilter(inputValue, option) {
    try {
      return option.props.children.toLowerCase().startsWith(inputValue.toLowerCase());
    } catch (e) {
      return option.props.value.toLowerCase().startsWith(inputValue.toLowerCase());
    }
  },

  isModuleDisabled(projects, moduleName, pId) {
    const currentProject = projects.find(project => project.id === Number(pId));
    const foundModule = currentProject.modules.find(m => m.code === moduleName);
    return foundModule ? foundModule.disabled : true;
  },

  getUniqueCustomBranches(codes) {
    let customBranches = [];
    const customBranchesKeys = new Set();
    if (codes) {
      codes.forEach((c) => {
        if (c && c.branches && c.branches.length) {
          const uniqueBranches = c.branches.filter((b) => {
            const result = customBranchesKeys.has(b.id);
            customBranchesKeys.add(b.id);
            return !result;
          });
          customBranches = [...customBranches, ...uniqueBranches];
        }
      });
    }

    return customBranches;
  },

  compileUrl(routeName, params) {
    return pathToRegexp.compile(Routes[routeName].path)(params);
  },

  isValidPassword(passwd) {
    return passwd.length >= 8;
  },

  formatTranslations(translations, locales) {
    return locales.reduce((result, item) => {
      return {
        ...result,
        [item]: _.pick(translations.filter(translate => translate.locale === item)[0], ['name']).name || null,
      };
    }, {});
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/utils/helpers.js